module.exports = __webpack_public_path__ + "static/img/ZZ.c9d8f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ZZ.png
// module id = P3mY
// module chunks = 18